import { render } from "./Arena_Chat_Item.vue?vue&type=template&id=306f7dde&scoped=true"
import script from "./Arena_Chat_Item.vue?vue&type=script&lang=js"
export * from "./Arena_Chat_Item.vue?vue&type=script&lang=js"

import "./Arena_Chat_Item.vue?vue&type=style&index=0&id=306f7dde&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306f7dde"]])

export default __exports__